const languages = [
    'en-US','da-DK','it-IT','de-DE','fr-FR','es-ES','sv-SE','no-NO','fi-FI','pl-PL','pt-PT'
];

export default languages;


